// Shim over @symbo.ls/sdk-bridge. This module used to own the Supabase
// client directly; it now re-exports from the federation layer so
// every existing import (getSupabase / getSupabaseAsync / SUPABASE_URL /
// SUPABASE_ANON_KEY) keeps working unchanged while the underlying
// client, session state, and new federation APIs live in sdk-bridge.
//
// New code should import from '../governanceBridge.js' directly — or, for
// governance-specific work, use `getClient(PROJECT_GOVERNANCE)`.

import {
  getSupabase,
  getSupabaseAsync,
  getRealtimeSupabase,
  getProjectConfig,
  PROJECT_GOVERNANCE
} from '../governanceBridge.js'
import { createClient } from '@supabase/supabase-js'

const _cfg = getProjectConfig(PROJECT_GOVERNANCE)

// Preserve the legacy constant exports. Anything pinned to these values
// (e.g. edge-function URLs built from the raw Supabase URL) keeps working.
//
// `RAW_URL` is the raw Supabase project URL — exported under this name
// (instead of `SUPABASE_URL`) because supabaseConfig.js exports the
// passthrough URL as `SUPABASE_URL` and frank's duplicate-export scan
// rejects two files in the same barrel exporting the same name.
// supabaseConfig.js also re-exports it as `RAW_SUPABASE_URL`.
export const RAW_URL = _cfg.url
export const SUPABASE_KEY = _cfg.anonKey
export const SUPABASE_ANON_KEY = _cfg.anonJwt

export { getSupabase, getSupabaseAsync, getRealtimeSupabase, createClient }
